import initEETrialBanner from 'ee/ee_trial_banner';
import { initSamlReloadModal } from 'ee/saml_sso/index';

// EE specific calls
initEETrialBanner();

initSamlReloadModal();
